export default "__VITE_PUBLIC_ASSET__5bfa432a__"